// extracted by mini-css-extract-plugin
export var container = "layout-module--container--58405";
export var pageContent = "layout-module--pageContent--260e7";